// Minimal toast queue. Single toast at a time; auto-dismiss after 3.5s.

import { useCallback, useEffect, useRef, useState } from 'react';

export type ToastTone = 'info' | 'warn' | 'error';

export interface Toast {
  id: number;
  message: string;
  tone: ToastTone;
}

let nextId = 1;

export function useToast(): {
  toast: Toast | null;
  show: (message: string, tone?: ToastTone) => void;
} {
  const [toast, setToast] = useState<Toast | null>(null);
  const timerRef = useRef<number | null>(null);

  const show = useCallback((message: string, tone: ToastTone = 'info') => {
    if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    const id = nextId++;
    setToast({ id, message, tone });
    timerRef.current = window.setTimeout(() => {
      setToast((current) => (current?.id === id ? null : current));
    }, 3500);
  }, []);

  useEffect(() => () => {
    if (timerRef.current !== null) window.clearTimeout(timerRef.current);
  }, []);

  return { toast, show };
}
